import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';
import type { FailureReason } from '@Application/Security/TokenJourney/FailureReason';

export type PasswordResetFetchFailedAction = {
	type: 'PASSWORD_RESET_FETCH_FAILED';
	payload: ExtractedMessages;
	reason: FailureReason;
	message: string;
};

export default (
	payload: ExtractedMessages,
	reason: FailureReason,
	message: string,
): PasswordResetFetchFailedAction => ({
	type: 'PASSWORD_RESET_FETCH_FAILED',
	payload,
	reason,
	message,
});
